import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {TempScore} from "../domain/temp-score";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TemporaryScoreService {

  private readonly SERVICE_URL = `/api/temp-score`;

  constructor(private http: HttpClient) {
  }

  createTemporaryScore(userName: string): Observable<TempScore> {
    return this.http.post<TempScore>(this.SERVICE_URL, {userName});
  }
}
